import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Row,
  Col,
  Container,
  Card,
} from "reactstrap";
import axios from "axios";
import Header from "components/Headers/Header";
import { useParams } from "react-router-dom";
import EditaEquiposOrden from "components/Ordenes/EditaEquiposOrden";
import Cookies from "universal-cookie";

const ActualizarOrden = ({ OrdenId, onSuccess }) => {
  const [certificadores, setCertificadores] = useState([]);
  const [certificadorId, setCertificadorId] = useState("");
  const [estado, setEstado] = useState("Presentado");
  const [fechaConversion, setFechaConversion] = useState("");
  const [bloqueado, setBloqueado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [debugData, setDebugData] = useState(null);

  const cookie = new Cookies();
  const { idOrden } = useParams();

  useEffect(() => {
    cargarInformacion();
  }, [OrdenId]);

  // =============================
  // Cargar información general
  // =============================
  const cargarInformacion = async () => {
    await obtenerCertificadores();
    await validarIcontec();
  };

  // =============================
  // Obtener certificadores
  // =============================
  const obtenerCertificadores = async () => {
    try {
      const res = await axios.get(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerCertificadores",
      );

      console.log("📌 Certificadores API:", res.data);

      setCertificadores(res.data);
      setDebugData(res.data);
    } catch (error) {
      console.error("❌ Error obteniendo certificadores:", error);
      console.error("Detalle:", error.response?.data);
    }
  };

  // =============================
  // Validar si la orden es ICONTEC
  // =============================
  const validarIcontec = async () => {
    try {
      const res = await axios.get(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/CertificadoPorIcontec/${idOrden}`,
      );

      console.log("📌 CertificadoPorIcontec API:", res.data);

      if (res.data) {
        setCertificadorId(1);
        setBloqueado(true);
      }
    } catch (error) {
      console.log("❌ Error CertificadoPorIcontec:", error.response?.data);
      setBloqueado(false);
    }
  };

  // =============================
  // Recargar información manual
  // =============================
  const recargarInformacion = async () => {
    window.location.reload("/");
  };

  // =============================
  // Actualizar orden
  // =============================
  const actualizarOrden = async (e) => {
    e.preventDefault();

    if (!certificadorId) {
      alert("Debe seleccionar un certificador");
      return;
    }

    if (!fechaConversion) {
      alert("Debe seleccionar la fecha de conversión");
      return;
    }

    setLoading(true);

    const body = {
      Estado: estado,
      FechaConversion: new Date(fechaConversion).toISOString(),
      CertificadorId: parseInt(certificadorId),
      InspectorId: cookie.get("id"),
    };

    console.log("📤 Body enviado:", body);

    try {
      const response = await axios.put(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ActualizaOrdenes/${idOrden}`,
        body,
      );

      console.log("✅ Respuesta ActualizaOrdenes:", response.data);
      setDebugData(response.data);

      alert(response.data);

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("❌ Error al actualizar:", error);
      console.error("Detalle backend:", error.response?.data);
      alert("Error al actualizar la orden");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      <Container className="mt--7" fluid>
        <div className="col">
          <h3>ORDEN {idOrden}</h3>

          <Card className="shadow p-4">
            <Form onSubmit={actualizarOrden}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Fecha Conversión</Label>
                    <Input
                      type="date"
                      value={fechaConversion}
                      onChange={(e) => setFechaConversion(e.target.value)}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label>Estado</Label>
                <Input
                  type="select"
                  value={estado}
                  onChange={(e) => setEstado(e.target.value)}
                >
                  <option value="En Revisión">En Revisión</option>
                  <option value="Rechazado">Rechazado</option>
                  <option value="Presentado">Presentado</option>
                  <option value="Finalizado">Finalizado</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Certificador</Label>
                <Input
                  type="select"
                  value={certificadorId}
                  onChange={(e) => setCertificadorId(e.target.value)}
                  disabled={bloqueado}
                  required
                >
                  <option value="">Seleccione...</option>
                  {certificadores.map((cert) => (
                    <option key={cert.id} value={cert.id}>
                      {cert.nombre}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <div className="text-end">
                <Button color="primary" type="submit" disabled={loading}>
                  {loading ? <Spinner size="sm" /> : "Actualizar Orden"}
                </Button>
              </div>
            </Form>
          </Card>

          {/* BOTÓN PARA RECARGAR */}
          <div className="text-center mt-4">
            <Button color="warning" onClick={recargarInformacion}>
              Si no puede ver la información haga click acá para recargar la
              información
            </Button>
          </div>
        </div>
      </Container>

      {/* COMPONENTE MODAL EQUIPOS */}
      <EditaEquiposOrden
        idOrden={idOrden}
        onClose={() => recargarInformacion()}
      />
    </>
  );
};

export default ActualizarOrden;
